import React, { useEffect, useState } from 'react';
import CreateAccountDialog from './dialogs/CreateAccoutDialog';
import RegWall from './dialogs/RegWall';

/**
 * Renders a paywall component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {boolean} props.open - The initial open state of the paywall.
 * @param {function} props.setIsPremium - A function to set the premium status.
 * @param {boolean} props.isAnon - A flag indicating if the user is anonymous.
 * @returns {JSX.Element} The paywall component.
 */
const Paywall = ({ open: initialOpen, setIsPremium, isAnon }) => {

    const [open, setOpen] = useState(initialOpen);
    const [showCreateAccount, setShowCreateAccount] = useState(false);

    useEffect(() => {
        setOpen(initialOpen);
    }, [initialOpen]);

    const handleButtonUpgrade = () => {
        if (isAnon) {
            setOpen(false);
            setShowCreateAccount(true);
        } else {
            setIsPremium(true);
            setOpen(false);
        }

    }

    const onClose = () => {
        setOpen(false);
    }

    return (
        showCreateAccount ?
            <CreateAccountDialog showCreateAccount={showCreateAccount} setShowCreateAccount={setShowCreateAccount} />
            :
            <RegWall open={open} onClose={onClose} isAnon={isAnon} handleButtonUpgrade={handleButtonUpgrade} />
    );
};

export default Paywall;
